



































import Vue from 'vue';
import { mapGetters } from "vuex";
import OctKpiCard from "@/components/Dashboard/OctKpiCard.vue";
import OctExportDialog from "@/components/Dashboard/OctExportDialog.vue";
import { DEPOTKPI, DASHBOARD_STORE, FETCH_DEPOTKPI, DEPOTKPI_LOADING } from "@/common/store/modules/DashboardStore";

export default Vue.extend({
  name: 'OctDepotKpi',
  components: {
    OctKpiCard,
    OctExportDialog
  },
  data () {
    return {
      exportDialogOpen: false
    };
  },
  computed: {
    ...mapGetters(DASHBOARD_STORE, [DEPOTKPI, DEPOTKPI_LOADING])
  },
  created(): void {
    this.$store.dispatch(FETCH_DEPOTKPI);
  },
  methods: {
    openExportDialog () {
      this.exportDialogOpen = true;
    }
  }
});
